import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaipunecabbooking() {



const cardData = {
  keyword: " Mumbai Pune Cab Booking  ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune cab booking services, ensuring a hassle-free travel experience for business trips, airport transfers, family outings, and leisure travel. Travelers can book cabs easily online or via phone, with professional drivers, well-maintained vehicles, and timely pickups. We offer one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With 24/7 customer support, Velocity Cab makes Mumbai to Pune travel convenient, safe, and stress-free.",

topPlaces: [
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Mumbai to Pune Taxi Fare Return",
description: "Mumbai to Pune taxi fare return service provides convenient round-trip travel for passengers who need transportation from Mumbai to Pune and back. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel through the Mumbai–Pune Expressway. Professional drivers provide safe driving, punctual pickup, and flexible waiting time depending on passenger schedules. This service is ideal for business meetings, family visits, sightseeing tours, and corporate trips. Travelers can enjoy air-conditioned vehicles, spacious seating, and adequate luggage space for long-distance journeys. Transparent pricing helps passengers plan their return trips easily without worrying about hidden charges. Online booking allows quick confirmation and reliable intercity travel. Passengers benefit from comfortable rides and professional service throughout the journey."
},
{
name: "Mumbai to Wanwadi Cab Service",
description: "Mumbai to Wanwadi cab service offers reliable transportation between Mumbai and Wanwadi in Pune. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel with experienced drivers managing long-distance routes safely. Pickup services are available from homes, offices, hotels, railway stations, and airports across Mumbai. This taxi service is suitable for business travelers, families, and tourists visiting residential areas in Wanwadi. Spacious interiors and luggage capacity make long-distance journeys comfortable. Air-conditioned vehicles ensure pleasant travel throughout the trip. Online booking options allow travelers to reserve rides instantly with transparent pricing. Safe driving and punctual service make the journey convenient and stress-free."
},
{
name: "Mumbai to Mundwa Cab Service",
description: "Mumbai to Mundwa cab service provides dependable transportation between Mumbai and the rapidly developing Mundwa area of Pune. Travelers can enjoy comfortable rides in well-maintained vehicles such as sedan, Ertiga, and Innova. Professional drivers provide safe highway driving and timely pickup services from any location across Mumbai. This service is ideal for corporate travelers heading to IT offices and residential complexes in Mundwa. Spacious vehicles provide comfortable seating and adequate luggage space. Smooth expressway travel ensures a faster journey between the cities. Online booking allows easy ride scheduling with instant confirmation. Transparent fares make the service reliable and affordable."
},
{
name: "Mumbai to Wadgaon Sheri Cab Service",
description: "Mumbai to Wadgaon Sheri cab service provides reliable intercity transportation between Mumbai and Wadgaon Sheri in Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide punctual pickup services from homes, offices, and hotels across Mumbai. The service is ideal for business travelers, families, and airport passengers traveling to Pune. Spacious seating and air-conditioned interiors make the long-distance journey comfortable. Travelers benefit from safe driving and experienced drivers familiar with expressway routes. Online booking makes it easy to schedule rides and receive instant confirmation. Flexible pickup options add convenience for passengers."
},
{
name: "Mumbai to Nigdi Cab Service",
description: "Mumbai to Nigdi cab service provides convenient transportation between Mumbai and Nigdi in the Pimpri Chinchwad region. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel along the Mumbai–Pune Expressway. Professional drivers offer punctual pickup services and safe driving throughout the journey. This service is ideal for corporate travelers, families, and tourists visiting PCMC areas. Spacious vehicles allow comfortable seating and luggage storage. Online booking platforms allow passengers to reserve taxis easily with transparent pricing. Reliable service ensures comfortable intercity travel."
},
{
name: "Mumbai to Swargate Cab",
description: "Mumbai to Swargate cab service offers dependable transportation between Mumbai and Swargate in central Pune. Comfortable vehicles ensure smooth expressway travel with professional drivers providing safe driving and punctual pickups. This service is widely used by passengers traveling to Pune bus station, hotels, and nearby residential areas. Air-conditioned vehicles ensure comfortable long-distance travel. Spacious seating and luggage capacity make the journey convenient for travelers. Online booking ensures easy ride scheduling and transparent fare details."
},
{
name: "Mumbai to Pune Station Cab",
description: "Mumbai to Pune Station cab service provides reliable transportation between Mumbai and Pune Railway Station. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel. Professional drivers provide timely pickups and safe driving throughout the journey. This service is ideal for passengers connecting to train services from Pune station. Spacious vehicles provide comfortable seating and luggage space for travelers. Online booking ensures easy scheduling and reliable transportation."
},
{
name: "Mumbai to Shivaji Nagar Cab",
description: "Mumbai to Shivaji Nagar cab service provides convenient transportation between Mumbai and the Shivaji Nagar area in Pune. Comfortable vehicles ensure smooth expressway travel with professional drivers handling the highway route safely. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. This taxi service is ideal for travelers visiting central Pune locations including Shivaji Nagar railway station and nearby offices. Spacious interiors ensure comfortable long-distance journeys."
},
{
name: "Mumbai Pune Taxi Booking",
description: "Mumbai Pune taxi booking service allows passengers to easily reserve taxis between the two cities. Travelers can book rides online and choose from vehicles such as sedan, Ertiga, and Innova depending on travel needs. Professional drivers provide safe driving and punctual pickup services from homes, offices, and hotels across Mumbai and Pune. Comfortable vehicles ensure smooth expressway travel. Online booking ensures transparent pricing and instant confirmation. This service is ideal for both business and leisure travel."
},
{
name: "Mumbai to Pune Cab",
description: "Mumbai to Pune cab service provides reliable transportation between the two major cities through the Mumbai–Pune Expressway. Comfortable vehicles ensure safe and smooth travel with experienced drivers handling the highway route professionally. Pickup services are available from homes, offices, hotels, railway stations, and airports across Mumbai. Travelers can choose from sedan, Ertiga, and Innova vehicles based on comfort and group size. This service is widely used for business travel, airport transfers, family trips, and tourist visits. Air-conditioned vehicles and spacious seating ensure comfortable long-distance journeys."
},
{
name: "Pune to Mumbai Cabs",
description: "Pune to Mumbai cab service provides dependable transportation for passengers traveling from Pune to Mumbai. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel via the expressway. Professional drivers provide punctual pickup services from various areas in Pune including Hinjewadi, Baner, Wakad, and Kharadi. This service is ideal for airport transfers, corporate travel, and family trips. Air-conditioned vehicles and comfortable seating make the journey relaxing and safe."
},
{
name: "Mumbai to Pune Cab Service",
description: "Mumbai to Pune cab service offers reliable intercity transportation with comfortable vehicles and professional drivers. Passengers can schedule rides from anywhere in Mumbai including residential areas, offices, railway stations, and airport terminals. Smooth expressway travel ensures faster and safer journeys. Travelers benefit from flexible booking options and transparent pricing. Comfortable seating and spacious luggage capacity ensure relaxed travel. This service is ideal for both business travelers and families."
},
{
name: "Pune to Mumbai Cab Service",
description: "Pune to Mumbai cab service provides dependable transportation for travelers heading from Pune to Mumbai city. Comfortable vehicles ensure smooth highway travel while experienced drivers provide safe driving and punctual pickup services. Travelers can book rides from multiple Pune locations including Hinjewadi, Baner, Wakad, and Kothrud. Online booking ensures convenient ride scheduling and transparent fare details."
},
{
name: "Pune Mumbai Taxi Service",
description: "Pune Mumbai taxi service offers convenient intercity transportation between Pune and Mumbai. Travelers can enjoy comfortable rides with experienced drivers and well-maintained vehicles. The service supports airport transfers, corporate travel, tourist trips, and family visits. Smooth expressway travel ensures quick and reliable journeys."
},
{
name: "Pune to Mumbai Cab Booking",
description: "Pune to Mumbai cab booking allows passengers to easily reserve taxis through online platforms. Travelers can choose vehicles such as sedan, Ertiga, and Innova based on travel needs. Professional drivers provide safe highway travel and punctual pickup services. Online booking ensures transparent pricing and instant confirmation."
},
{
name: "Cab Service Mumbai to Pune",
description: "Cab service Mumbai to Pune offers dependable intercity transportation between the two cities. Comfortable vehicles ensure smooth expressway travel with experienced drivers providing safe driving and reliable service. Flexible booking options make travel convenient for passengers."
},
{
name: "Mumbai to Pune Taxi Charges",
description: "Mumbai to Pune taxi charges service provides clear pricing details for passengers traveling between the two cities. Travelers can choose vehicles according to their budget and comfort preferences. Transparent fare details help passengers plan their journey easily."
},
{
name: "Mumbai to Pune Innova Cab",
description: "Mumbai to Pune Innova cab service provides spacious SUV transportation for passengers traveling between the cities. Toyota Innova vehicles offer comfortable seating, smooth highway performance, and extra luggage capacity. Professional drivers ensure safe and reliable journeys."
},
{
name: "Mumbai to Pune Innova Crysta on Rent",
description: "Mumbai to Pune Innova Crysta on rent service offers premium SUV transportation for comfortable long-distance travel. Innova Crysta vehicles provide luxury interiors, spacious seating, and smooth highway performance. This service is ideal for family trips and corporate travel."
},
{
name: "Mumbai Pune Cab Booking",
description: "Mumbai Pune cab booking service allows passengers to reserve taxis easily for intercity travel. Travelers can select vehicle types, choose pickup locations, and confirm bookings instantly through online platforms."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking provides convenient ride reservation for passengers traveling between the two cities. Comfortable vehicles and experienced drivers ensure safe and reliable travel."
},
{
name: "Pune to Mumbai Cab Booking",
description: "Pune to Mumbai cab booking allows travelers to schedule rides easily through online booking platforms. Comfortable vehicles and professional drivers ensure smooth expressway travel."
},
{
name: "Book Cab Mumbai to Pune",
description: "Book cab Mumbai to Pune service allows travelers to quickly reserve taxis for intercity travel. Passengers can choose comfortable vehicles and schedule rides according to their travel plans."
},
{
name: "Online Cab Booking Mumbai to Pune",
description: "Online cab booking Mumbai to Pune provides convenient digital booking options for travelers. Passengers can easily reserve taxis through websites or mobile platforms and enjoy comfortable expressway travel."
},
{
name: "Mumbai Pune Taxi Booking",
description: "Mumbai Pune taxi booking service provides easy ride reservations for passengers traveling between the two cities. Comfortable vehicles and professional drivers ensure safe and smooth journeys."
},
{
name: "One Way Cab Mumbai to Pune",
description: "One way cab Mumbai to Pune service provides economical travel for passengers who need transportation in a single direction. Travelers can enjoy comfortable vehicles and transparent fares without paying for return trips."
},
{
name: "Mumbai Pune Cab Service",
description: "Mumbai Pune cab service provides reliable transportation between the two cities with comfortable vehicles and experienced drivers. Passengers benefit from smooth expressway travel, flexible booking options, and professional service."
}
],

tableData: [
["Mumbai to Pune Taxi Fare Return","Mumbai to Wanwadi Cab Service"],
["Mumbai to Mundwa Cab Service","Mumbai to Wadgaon Sheri Cab Service"],
["Mumbai to Nigdi Cab Service","Mumbai to Swargate Cab"],
["Mumbai to Pune Station Cab","Mumbai to Shivaji Nagar Cab"],
["Mumbai Pune Taxi Booking","Mumbai to Pune Cab"],
["Pune to Mumbai Cabs","Mumbai to Pune Cab Service"],
["Pune to Mumbai Cab Service","Pune Mumbai Taxi Service"],
["Pune to Mumbai Cab Booking","Cab Service Mumbai to Pune"],
["Mumbai to Pune Taxi Charges","Mumbai to Pune Innova Cab"],
["Mumbai to Pune Innova Crysta on Rent","Mumbai Pune Cab Booking"],
["Mumbai to Pune Cab Booking","Pune to Mumbai Cab Booking"],
["Book Cab Mumbai to Pune","Online Cab Booking Mumbai to Pune"],
["Mumbai Pune Taxi Booking","One Way Cab Mumbai to Pune"],
["Mumbai Pune Cab Service","Mumbai to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Easy Mumbai Pune Cab Booking",
    WhyChoosedescription: "Velocity Cabs offers a quick and simple Mumbai Pune cab booking service. Customers can easily reserve their ride through phone or online booking with instant confirmation for a smooth travel experience."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel between Mumbai and Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Our Mumbai Pune cab booking service operates 24 hours a day. Whether you need early morning travel, business trips, airport transfers, or late-night rides, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing intercity travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including one-way cab service, round-trip travel, airport transfers, and customized travel plans between Mumbai and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Pune cab booking thanks to punctual drivers, comfortable vehicles, and professional intercity transportation service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Pune cab booking service?", answer: "Yes, Velocity Cabs provides reliable cab booking services between Mumbai and Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Mumbai from Pune?", answer: "The road distance between Mumbai and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic conditions." },
  { question: "Is Mumbai Pune cab booking available 24 hours?", answer: "Yes, our cab booking service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mumbai Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Mumbai and Pune." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, our drivers provide pickup from Mumbai Airport, homes, hotels, offices, and railway stations across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Pune cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, Velocity Cabs provides drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Joshi",
    feedback:
      "Quick cab booking from Mumbai to Pune made the entire travel experience very smooth. The ride was comfortable, punctual, and well-managed throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "Simple and hassle-free Mumbai Pune cab booking experience. The vehicle was clean, the driver was professional, and the trip felt safe and relaxed.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Pune Cab Booking | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Mumbai to Pune cab booking with professional drivers and affordable fares. Book one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for city-to-city travel, airport transfers, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai Pune Cab Booking | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for city-to-city travel, airport transfers & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaipunecabbooking;